<template>
    <div class="CreateSingleParticipantDiv">
        <div class="container-fluid">
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    First Name
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.FirstName">
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    Last Name
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.LastName">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    Username
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.UserName">
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    Email
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.EmailId">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    Password
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.Password">
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    User Location
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.UserLocation">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    School
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.School">
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    Self Summary
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.SelfSummary">
                        </div>
                    </div>
                </div>
            </div>    
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    Picture
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="file" id="userPicture" accept=".jpg, .jpeg, .png">
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    Session Timeout
                </div>    
                <div class="col-md-2 col-lg-2">
                    <div class="form-group">
                        <div class="col-sm-4">
                            <span class="glyphicon glyphicon-plus-sign cursor-pointer" @click="counter($event,'+')"></span>
                        </div>
                        <div class="col-sm-4 font-weight-bold font-size-18px">
                            {{userObj.SessionTimeout}}
                        </div>
                        <div class="col-sm-4">
                            <span class="glyphicon glyphicon-minus-sign cursor-pointer" @click="counter($event,'-')"></span>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="getSessiontimeOutUnit">
                            <!-- <option value=-1 disabled>Timeout Unit</option> -->
                            <option value=0>Minute(s)</option>
                            <option value=1>Hour(s)</option>
                            <option value=2>Day(s)</option>
                          </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    Gender
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="userObj.Gender">
                                <option value=-1 disabled>Select</option>
                                <option value=0>Male</option>
                                <option value=1>Female</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    User Group
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="userObj.Group">
                                <option value=-1 disabled>Select</option>
                                <option value=0>None</option>
                                <option value=1>TCS</option>
                                <option value=2>Morgan Stanley</option>
                                <option value=3>Deloitte</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    Account Type
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="getUserAccountTypeValue">
                                <option value=-1 disabled>Select account type</option>
                                <option value=0>User</option>
                                <option value=1>Group Admin</option>
                                <option value=2>Admin</option>
                                <option value=3>Coach</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right" v-if="getUserAccountTypeValue === 1">
									Admin Group
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group" v-if="getUserAccountTypeValue === 1">
                        <div class="col-sm-12">
													<select class="form-control Padding-right-0px" v-model="selectedGroupAdminObj">
														<option value=-1 disabled>Select</option>
														<option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                      		</select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    Group
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
													<select class="form-control Padding-right-0px" v-model="selectedGroupObj">
														<option value=-1 disabled>Select</option>
														<option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                      		</select>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    Cohort Name
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.CohortName">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                        <div class="checkbox">
                          <label><input type="checkbox" v-model="userObj.EnableMSTeams">Enable MS Team Notfications</label>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right" v-if="userObj.EnableMSTeams">
                  MS Team Email 
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group" v-if="userObj.EnableMSTeams">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="userObj.MSTeamEmailId">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="checkbox">
                            <label><input type="checkbox" v-model="userObj.DisableOffline">Disable Offline</label>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="checkbox">
                            <label><input type="checkbox" v-model="userObj.DisableProfileEdit">Disable Profile Edit</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-bottom-2Perc">    
                <div class="">
                    <!-- ToDo: Track this -->
                    <button class="btn btn-primary create-element-overlay-button-BG black-font-color" @click="createSingleParticipant">Create Participant</button>
                </div>    
            </div>      
        </div>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
            <div class="osahanloading"></div>
        </div>
        <loader></loader>
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
        <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixUserEnrollmentConfirmationString" v-bind:postfixString="postUserEnrollmentConfirmationString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="updateShowUserEnrollmentOverlayFlag"></confirmation-alert>
        <enroll-single-created-participant-overlay v-if="showUserEnrollmentOverlay" v-bind:createdParticipantObj="createdParticipantObj" @updateFlag="updateOpenEnrollParticipantOverlayFlag"></enroll-single-created-participant-overlay>
    </div>    
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import EnrollSingleCreatedParticipantOverlay from '@/components/EnrollSingleCreatedParticipantOverlay'
import { participantService } from '@/server-util/participant-service'
import { constants } from '@/utils/constants'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { groupService } from '@/server-util/group-service'
export default {
  beforeDestroy: function () {
    this.resetUserObj()
  },
  mounted: function () {
    this.resetUserObj()
  },
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      userObj: {
        FirstName: '',
        LastName: '',
        EmailId: '',
        UserName: '',
        Disabled: false,
        DisableOffline: false,
        DisableProfileEdit: false,
        EnableMSTeams: false,
        MSTeamEmailId: '',
        AccountType: -1,
        Gender: -1,
        SelfSummary: '',
        UserLocation: '',
        CohortName: '',
        School: '',
        SessionTimeout: 0,
        SessionTimeoutUnit: 0,
        Group: -1,
        Password: null,
        GroupId: ''
      },
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixUserEnrollmentConfirmationString: '',
      postUserEnrollmentConfirmationString: '',
      showUserEnrollmentOverlay: false,
      createdParticipantObj: [],
      sessionTimeOutUpperLimit: 60,
      selectedGroupAdminObj: -1,
      selectedGroupObj: -1
    }
  },
  methods: {
    validateEmail: function (emailId) {
      /* eslint-disable */
      var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      /* eslint-enable */
      return mailformat.test(emailId)
    },
    checkUserImageExtension: function (fileName) {
      var exts = ['.jpg', '.jpeg', '.png']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    counter: function (event, selectedOperation) {
      switch (selectedOperation) {
        case '+':
          this.userObj.SessionTimeout += 1
          if (this.sessionTimeOutUpperLimit !== this.userObj.SessionTimeout) {
          } else {
            if (this.userObj.SessionTimeout === 60 && this.sessionTimeOutUpperLimit === 60) {
              this.userObj.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Hours)
              this.userObj.SessionTimeout = 1
              this.sessionTimeOutUpperLimit = 24
            } else if (this.userObj.SessionTimeout === 24 && this.sessionTimeOutUpperLimit === 24) {
              this.userObj.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Days)
              this.userObj.SessionTimeout = 1
              this.sessionTimeOutUpperLimit = 365
            }
          }
          break
        case '-':
          if (this.userObj.SessionTimeout !== 0) {
            this.userObj.SessionTimeout -= 1
            if (this.sessionTimeOutUpperLimit !== this.userObj.SessionTimeout) {
              if (this.userObj.SessionTimeout === 0 && this.sessionTimeOutUpperLimit === 24) {
                this.userObj.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Minutes)
                this.userObj.SessionTimeout = 59
                this.sessionTimeOutUpperLimit = 60
              } else if (this.userObj.SessionTimeout === 0 && this.sessionTimeOutUpperLimit === 365) {
                this.userObj.SessionTimeoutUnit = parseInt(constants.SessionTimeoutUnit.Hours)
                this.userObj.SessionTimeout = 23
                this.sessionTimeOutUpperLimit = 24
              }
            }
          }
          break
      }
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    createSingleParticipant: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var userPicture = document.getElementById('userPicture').files[0]
        if (userPicture !== undefined && userPicture !== null) {
          if (
            !this.checkUserImageExtension(
              document.getElementById('userPicture').value
            )
          ) {
            this.showAlertDialog = true
            this.errorMsg =
              'Please select .jpg, .jpeg or .png file.'
            return
          }
        } else {
          userPicture = null
        }
        const formData = new FormData()
        formData.append('FirstName', this.userObj.FirstName)
        formData.append('LastName', this.userObj.LastName)
        formData.append('EmailId', this.userObj.EmailId)
        formData.append('UserName', this.userObj.UserName)
        formData.append('Disabled', this.userObj.Disabled)
        formData.append('DisableOffline', this.userObj.DisableOffline)
        formData.append('DisableProfileEdit', this.userObj.DisableProfileEdit)
        formData.append('EnableMSTeams', this.userObj.EnableMSTeams)
        formData.append('MSTeamEmailId', this.userObj.EnableMSTeams ? this.userObj.MSTeamEmailId : null)

        // AK: IF user not selected Account type then assign User
        if (parseInt(this.userObj.AccountType) === -1) {
          this.userObj.AccountType = 0
        }
        formData.append('AccountType', parseInt(this.userObj.AccountType))

        if (parseInt(this.userObj.AccountType) === 1) {
          this.userObj.GroupAdminId = this.selectedGroupAdminObj.GroupId
          formData.append('GroupAdminId', this.selectedGroupAdminObj.GroupId)
        }
        formData.append('GroupId', this.selectedGroupObj.GroupId)
        // AK: If user not selected group then assign None
        if (parseInt(this.userObj.Group) === -1) {
          // this.userObj.Group = 0
          formData.append('Group', 0)
        } else {
          formData.append('Group', parseInt(this.userObj.Group))
        }
        // AK: If user not select gender then assign Male
        if (parseInt(this.userObj.Gender) === -1) {
          this.userObj.Gender = 0
        }
        formData.append('Gender', parseInt(this.userObj.Gender))
        formData.append('SelfSummary', this.userObj.SelfSummary)
        formData.append('UserLocation', this.userObj.UserLocation)
        formData.append('School', this.userObj.School)
        formData.append('SessionTimeout', this.userObj.SessionTimeout)
        formData.append('SessionTimeoutUnit', this.userObj.SessionTimeoutUnit)
        formData.append('ImageFile', userPicture)
        formData.append('Password', this.userObj.Password)
        formData.append('CohortName', this.userObj.CohortName)
        // console.log(JSON.stringify(this.userObj))
        var _this = this
        var storeObj = this.$store
        if (
          formData !== undefined ||
          formData !== '' ||
          formData !== undefined
        ) {
          // AK: Start showing spinner
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          participantService
            .createSingleParticipant(storeObj.state.access_token, formData)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                  // this.showAlertDialog = true
                  // this.errorMsg = '"' + this.userObj.FirstName + this.userObj.LastName + '" created successfully.'
                  if (this.userObj.AccountType !== constants.UserAccountType.Group_Admin && this.userObj.AccountType !== constants.UserAccountType.Admin && this.userObj.CohortName.length === 0) {
                    this.prefixUserEnrollmentConfirmationString =
                    '\'' +
                    this.userObj.FirstName +
                    ' ' +
                    this.userObj.LastName +
                    '\' created successfully. '
                    this.postUserEnrollmentConfirmationString =
                      'Would you like to enroll in the course?'
                    this.showConfirmationBox = true
                  } else {
                    this.showAlertDialog = true
                    this.errorMsg = '\'' +
                    this.userObj.FirstName +
                    ' ' +
                    this.userObj.LastName +
                    '\' created successfully. '
                  }
                  this.createdParticipantObj = responseObj.data
                  // AK: Reset all user obj to create new user
                  this.resetUserObj()
                } else {
                  // AK: Hide Spinner
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected FormData is NULL hence declined CREATE PARTICIPANT OPERATION'
          )
        }
      }
    },
    resetUserObj: function () {
      this.userObj.FirstName = ''
      this.userObj.LastName = ''
      this.userObj.EmailId = ''
      this.userObj.UserName = ''
      this.userObj.Disabled = false
      this.userObj.DisableOffline = false
      this.userObj.DisableProfileEdit = false
      this.userObj.EnableMSTeams = false
      this.userObj.MSTeamEmailId = ''
      this.userObj.AccountType = -1
      this.userObj.Gender = -1
      this.userObj.SelfSummary = ''
      this.userObj.UserLocation = ''
      this.userObj.School = ''
      this.userObj.SessionTimeout = 0
      this.userObj.SessionTimeoutUnit = 0
      this.userObj.Group = -1
      this.userObj.Password = null
      this.userObj.GroupAdminId = ''
      this.userObj.CohortName = ''
      this.selectedGroupObj = -1
      document.getElementById('userPicture').value = ''
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of Enroll user dialog
      this.showConfirmationBox = value
    },
    updateShowUserEnrollmentOverlayFlag (value) {
      // AK: Hide Confirmation Overlay
      this.showConfirmationBox = false
      // AK: Used show User Enrollment if pressed okay
      if (value) {
        this.showUserEnrollmentOverlay = value
        // AK: Disable Background Scrolling
        this.$store.state.isOverlayVisible = value
      }
    },
    updateOpenEnrollParticipantOverlayFlag (value) {
      // AK: Used to close Enroll participant Overlay
      this.showUserEnrollmentOverlay = value
      // AK: Enabled Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.userObj.FirstName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'First name can\'t be empty.'
        return false
      } else if (this.userObj.LastName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Last name can\'t be empty.'
        return false
      } else if (this.userObj.UserName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Username can\'t be empty.'
        return false
      } else if (this.userObj.EmailId.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Email address can\'t be empty.'
        return false
      } else if (!this.validateEmail(this.userObj.EmailId)) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid email address provided.'
        return false
      } else if (this.userObj.Gender === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select the gender.'
        return false
      } else if (this.userObj.AccountType === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select the account type.'
        return false
      } else if (parseInt(this.userObj.AccountType) === 1 && this.selectedGroupAdminObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an admin group.'
        return false
      } else if (this.userObj.EnableMSTeams && this.userObj.MSTeamEmailId.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'MS Team Email Id can\'t be empty.'
        return false
      } else if (this.userObj.EnableMSTeams && !this.validateEmail(this.userObj.MSTeamEmailId)) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid MS Team Email Id provided.'
        return false
      } else if (this.selectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.userObj.CohortName.length > 0 && (!this.userObj.CohortName.replace(/\s/g, '').length)) {
        this.showAlertDialog = true
        this.errorMsg = 'Cohort name can\'t only have empty spaces.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'enroll-single-created-participant-overlay': EnrollSingleCreatedParticipantOverlay,
    'loader': Loader
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    getSessiontimeOutUnit: {
      get: function () {
        return this.userObj.SessionTimeoutUnit
      },
      set: function (newValue) {
        this.userObj.SessionTimeout = 0
        switch (parseInt(newValue)) {
          case 0:
            this.sessionTimeOutUpperLimit = 60
            break
          case 1:
            this.sessionTimeOutUpperLimit = 24
            break
          case 2:
            this.sessionTimeOutUpperLimit = 365
            break
        }
        this.userObj.SessionTimeoutUnit = parseInt(newValue)
      }
    },
    getUserAccountTypeValue: {
      get: function () {
        return this.userObj.AccountType
      },
      set: function (newValue) {
        this.selectedGroupAdminObj = -1
        this.userObj.AccountType = parseInt(newValue)
      }
    }
  },
  name: 'CreateSingleParticipantDiv'
}
</script>

<style scoped>
.height-50px {
  height: 50px;
}
.margin-bottom-0px {
  margin-bottom: 0px;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-right {
  text-align: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.background-color-red {
  background-color: red;
}
.border-black {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}

.font-size-18px {
  font-size: 18px;
}
.background-gray {
  background-color: #ddd;
}
.padding-top-bottom-point-7Perc {
  padding-top: 0.7% !important;
  padding-bottom: 0.7% !important;
}
.create-element-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.font-weight-bold {
  font-weight: bold;
}
.glyphicon {
  font-size: 22px;
}
</style>





// WEBPACK FOOTER //
// src/components/CreateSingleParticipant.vue